import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

type UserParams = {
  email?: string,
  username?: string,
}

export type Accounts = {
  email: string | null,
  phone: string | null,
  username: string | null,
}

const getUserAccounts = async ({ email, username }: UserParams) => {
  if (email) {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('email, phone, username')
      .eq('email', email)
      .maybeSingle();

    if (error) {
      throw new Error(error.message)
    }

    if (!data) {
      throw new Error('User not found')
    }

    return data as Accounts
  }
  const { data, error } = await supabase
    .from('user_profiles')
    .select('email, phone, username')
    .ilike('username', username || '')
    .maybeSingle();

  if (error) {
    throw new Error(error?.message)
  }

  if (!data) {
    throw new Error('User not found')
  }

  return data as Accounts
}

export default function useUserAccounts({
  email = '',
  username = '',
}: UserParams) {
  return useMutation(() => getUserAccounts({ username, email }))
}
